<template>

    <div class="text-sm">

        <div class="flex flex-row justify-between items-start gap-x-8">

            <div class="flex flex-grow items-start flex-col">

                <div class="font-bold flex flex-grow items-center" :class="{ 'text-gray-400': !canToggleSaml }"> SAML2
                    <span v-if="!canToggleSaml" class="text-sm text-gray-400 ml-1"> - Only available
                        <inertia-link v-if="$page.props.canManagePlan" :href="route('subscription.index')"
                            class="text-blue-500 hover:underline">for Business plans</inertia-link>
                        <span v-else class="text-gray-600">for Business plans</span>
                    </span>
                </div>

                <div class="text-sm mt-3">Connect with Azure AD, Google Workspace, Okta, and other SAML2 IdP -
                    &nbsp;<docs-link href="https://docs.birdie.so/birdie-docs/security/saml-sso" /></div>

            </div>

            <div class="flex flex-shrink">
                <toggle v-if="!saml_tenant || !plan_sso" :checked="false" @click.prevent.stop @update="toggleSaml">
                </toggle>

                <div v-else class="flex items-center gap-x-3">

                    <button
                        class="inline-flex items-center justify-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 disabled:cursor-default transition hover:opacity-70"
                        @click="toggleSaml">
                        Edit
                    </button>

                    <button
                        class="inline-flex items-center justify-center px-3 py-2 bg-red-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-red-700 active:bg-red-800 focus:outline-none focus:border-red-800 focus:ring focus:ring-red-800 disabled:opacity-25 disabled:cursor-default transition hover:opacity-70"
                        @click="ask_for_deletion = true">
                        <TrashIcon class="w-4 h-4"></TrashIcon>
                    </button>

                </div>
            </div>
        </div>

        <div class="flex flex-col mt-6" v-if="saml_tenant">

            <p class="text-sm font-bold text-gray-600">Service Provider EntityID: </p>
            <CopyField :copyText="saml_metadata" />

            <p class="text-sm font-bold text-gray-600 mt-3">Service Provider ACS: </p>
            <CopyField :copyText="saml_acs" />

            <p class="text-sm font-bold text-gray-600 mt-3" v-if="saml_sls">Service Provider SLS: </p>
            <CopyField :copyText="saml_sls" v-if="saml_sls" />

            <p class="text-sm font-bold text-gray-600 mt-3">Service Provider Name-ID Format: </p>
            <CopyField :copyText="saml_nameIdFormat" />

            <p class="text-sm font-bold text-gray-600 mt-3">Birdie Sign-in URL: </p>
            <CopyField :copyText="saml_login" />

        </div>

        <div v-else-if="saml_uuid && canToggleSaml" class="flex flex-col mt-6">

            <p class="text-sm font-bold text-gray-600">Service Provider EntityID: </p>
            <CopyField :copyText="'https://app.birdie.so/saml/' + saml_uuid + '/metadata'" />

            <p class="text-sm font-bold text-gray-600 mt-3">Service Provider ACS: </p>
            <CopyField :copyText="'https://app.birdie.so/saml/' + saml_uuid + '/acs'" />

            <!-- no sls -->

            <p class="text-sm font-bold text-gray-600 mt-3">Service Provider Name-ID Format: </p>
            <CopyField :copyText="'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress'" />

            <p class="text-sm font-bold text-gray-600 mt-3">Birdie Sign-in URL: </p>
            <CopyField :copyText="'https://app.birdie.so/login/' + saml_uuid" />

        </div>



        <jet-section-border v-if="saml_tenant" />

        <div class="flex flex-row justify-between items-start gap-x-8" v-if="saml_tenant">

            <div class="flex flex-grow items-start flex-col">

                <div class="font-bold flex items-center gap-x-2">Allow team members outside the SSO domain to sign in
                </div>

            </div>

            <div class="flex flex-shrink">
                <toggle :checked="!sso_forced" @click.prevent.stop @update="toggleForce"></toggle>
            </div>
        </div>


        <modal-saml ref="modalSaml" :saml_tenant="saml_tenant" :domains="sso_domains"
            @callback="toggleSamlResult"></modal-saml>


        <jet-confirmation-modal :show="ask_for_deletion" @close="ask_for_deletion = false">
            <template #title>
                Delete SSO Settings
            </template>

            <template #content>
                Confirm deletion of this SAML2 Setting?
            </template>

            <template #footer>
                <jet-secondary-button @click="ask_for_deletion = false">
                    Cancel
                </jet-secondary-button>

                <jet-danger-button class="ml-2" @click="delete_saml2" :class="{ 'opacity-25': delete_processing }"
                    :disabled="delete_processing">
                    Delete
                </jet-danger-button>
            </template>
        </jet-confirmation-modal>

    </div>

</template>

<script>

import Toggle from '@/Components/UI/Toggle'
import ModalSaml from '@/Components/Modals/SamlInfos'
import { TrashIcon } from "@heroicons/vue/24/solid"
//import JetModal from '@/Jetstream/Modal'
import JetConfirmationModal from '@/Jetstream/ConfirmationModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import CopyField from '@/Components/UI/CopyField'

import JetSectionBorder from '@/Jetstream/SectionBorder'

export default {

    props: ["saml_tenant_initial", "plan_sso", "saml_uuid"],

    components: {
        Toggle, ModalSaml, CopyField, JetSectionBorder,
        TrashIcon, JetDangerButton, JetSecondaryButton, JetConfirmationModal
    },

    created: function () {
        this.sso_domains = this.$page.props.user.current_team.sso_domains
        if (!this.sso_domains) {
            this.sso_domains = this.$page.props.user.current_team.owner.email.split('@')[1]
        }
        // console.log(this.sso_forced)
    },

    data() {
        return {
            saml_tenant: this.saml_tenant_initial,
            canToggleSaml: this.plan_sso,
            ask_for_deletion: false,
            delete_processing: false,
            sso_domains: this.$page.props.user.current_team.sso_domains,
            sso_forced: this.$page.props.sso_forced,
        }
    },

    mounted: function () {

    },

    methods: {
        delete_saml2: function () {
            if (!this.ask_for_deletion || !this.saml_tenant) {
                return
            }
            this.delete_processing = true
            this.toggleSamlResult({
                delete: this.saml_tenant.id,
                saml_label: null,
                saml_entity_id: null,
                saml_signon_url: null,
                saml_signout_url: null,
                saml_certificate: null
            })
        },
        toggleSaml() {
            if (!this.canToggleSaml) {
                return
            }
            if (this.saml_label) {
                this.toggleSamlResult({
                    saml_label: null,
                    saml_entity_id: null,
                    saml_signon_url: null,
                    saml_signout_url: null,
                    saml_certificate: null
                })
                return
            }
            this.$refs.modalSaml.open()
        },

        toggleSamlResult(obj) {

            let url = this.$page.props.api_url + '/v1/settings/saml';
            var params = {
                saml_label: obj.saml_label,
                saml_entity_id: obj.saml_entity_id,
                saml_signon_url: obj.saml_signon_url,
                saml_signout_url: obj.saml_signout_url,
                saml_certificate: obj.saml_certificate,
                sso_domains: obj.sso_domains
            };
            if (obj.delete) {
                params.delete = obj.delete
            }


            axios.post(url, params)
                .then(response => {

                    console.log("toggleSamlResult", response)

                    if (response.data) {

                        console.log("toggleSamlResult", response.data)

                        this.saml_tenant = response.data.tenant
                        this.sso_domains = response.data.sso_domains

                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        if (!params.delete) {
                            this.$moshaToast("SAML2 SSO details saved!", options)
                        } else {
                            this.$moshaToast("SAML2 SSO was successfully deleted", options)
                            this.saml_tenant = null
                            this.ask_for_deletion = false
                        }
                    }
                })
                .catch(e => {
                    console.error(e);
                    if (e.response) {

                        if (e.response.status == 422 && e.response.data.error) {

                            let options = {
                                type: "danger",
                                timeout: -1,
                                position: "top-right",
                            }
                            this.$moshaToast('Error: ' + e.response.data.error, options)
                        }
                    }

                });

            // if (this.privacy_policy_url) {
            //     this.widget_settings.privacy_policy_url = this.privacy_policy_url
            // } else {
            //     this.widget_settings.hide_zest_footer = "yes"
            // }
        },

        toggleForce: function () {
            if (this.saving) {
                return
            }
            this.sso_forced = !this.sso_forced
            this.updateMeta({
                meta: "sso_forced",
                value: this.sso_forced
            })
        },
        updateMeta: function (params) {
            this.saving = true
            let url = this.$page.props.api_url + '/v1/team/set_meta';
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.saving = false
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                });
        }

    },

    computed: {
        saml_metadata() {
            if (this.saml_tenant && this.plan_sso) {
                return this.$page.props.app_url + '/saml/' + this.saml_tenant.uuid + '/metadata'
            }
            return null
        },
        saml_acs() {
            if (this.saml_tenant && this.plan_sso) {
                return this.$page.props.app_url + '/saml/' + this.saml_tenant.uuid + '/acs'
            }
            return null
        },
        saml_sls() {
            if (this.saml_tenant && this.plan_sso) {
                if (this.saml_tenant.idp_logout_url != '') {
                    return this.$page.props.app_url + '/saml/' + this.saml_tenant.uuid + '/sls'
                }
            }
            return null
        },
        saml_nameIdFormat() {
            if (this.saml_tenant && this.plan_sso) {
                return 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress'
            }
            return null
        },
        saml_login() {
            if (this.saml_tenant && this.plan_sso) {
                return this.$page.props.app_url + '/login/' + this.saml_tenant.uuid
            }
            return null
        }
    }
}


</script>

<style scoped></style>
